import { Injectable } from '@angular/core';
import { MtnaSearchSelectionService } from '@mtna/search-manager-angular';
import { Result } from '@mtna/search-manager-ts';

import { RdsDataProductSelection } from '../models';

/**
 * An implementation of the {@link MtnaSearchSelectionService} that uses the search results catalog ID and data product ID as the underlying model.
 */
@Injectable({ providedIn: 'root' })
export class RdsSearchDpSelectionService extends MtnaSearchSelectionService<RdsDataProductSelection> {
  getModelFromResult(result: Result): RdsDataProductSelection {
    const selection: RdsDataProductSelection = { catalogId: '', dataProductId: '' };
    selection.catalogId = result.getFieldByName<string>('catalog_id')?.value || '';
    selection.dataProductId = result.getFieldByName<string>('id')?.value || '';
    return selection;
  }

  modelIsResult(model: RdsDataProductSelection, result: Result): boolean {
    const selection = this.getModelFromResult(result);
    return selection.catalogId === model.catalogId && selection.dataProductId === model.dataProductId;
  }
}
